import { render, staticRenderFns } from "./Geograficos.vue?vue&type=template&id=be59bf4c"
import script from "./Geograficos.vue?vue&type=script&lang=js"
export * from "./Geograficos.vue?vue&type=script&lang=js"
import style0 from "./Geograficos.vue?vue&type=style&index=0&id=be59bf4c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be59bf4c')) {
      api.createRecord('be59bf4c', component.options)
    } else {
      api.reload('be59bf4c', component.options)
    }
    module.hot.accept("./Geograficos.vue?vue&type=template&id=be59bf4c", function () {
      api.rerender('be59bf4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Views/Geograficos/Geograficos.vue"
export default component.exports